export default {
  id: 'settings',
  nav: [{ group: 'admin', label: 'Organization settings', path: '/settings', icon: 'settings', order: 140, permission: 'settings.update', match: /^\/settings/ }],
  routes: [
    // Every active member may view settings (RLS allows read); editing requires settings.update.
    { path: '/settings', title: 'Organization settings', breadcrumbs: ['Administration', 'Organization settings'], view: () => import('./views/org-settings.view.js') },
  ],
};
